export default __webpack_public_path__ + "static/media/(15).97cc4ed2.jpeg";